import AbsComponent from '../../common/components/AbsComponent';
import AbilityleftcontentsTempl from './AbilityleftcontentsTempl';
import AbilityrightcontentsTempl from './AbilityrightcontentsTempl';
import AbilityleftheaderTempl from './AbilityleftheaderTempl';
import AbilityrightheaderTempl from './AbilityrightheaderTempl';
import AbilityleftlayerTempl from './AbilityleftlayerTempl';
import AbilityrightlayerTempl from './AbilityrightlayerTempl';



/**
 * Sub1 class
 * @category testApp
 */
class AbilityInfo extends AbsComponent{
    constructor(_store={}, _el=''){
        super(_store, _el);
        this.store.getCharacterAbilityData(_store.data.config.serverType,_store.data.config.serverId, _store.data.config.characterName, this.render.bind(this));
    }

    render(_jsonData = {}){
        if(this.store.data.config.serverType === 'LIVE'){
            $(this.el +' .ability-left .ability-header').append(AbilityleftheaderTempl.getLeftHeaderTempl(_jsonData, this.store.data.config.serverType));
            $(this.el +' .ability-right .ability-header').append(AbilityrightheaderTempl.getRightHeaderTempl(_jsonData, this.store.data.config.serverType));
            $(this.el +' .ability-left .ability-header-layer').append(AbilityleftlayerTempl.getLeftLayerTempl(_jsonData));
            $(this.el +' .ability-right .ability-header-layer').append(AbilityrightlayerTempl.getRightLayerTempl(_jsonData));
        }
        if(this.store.data.config.serverType === 'NEO'){
            $(this.el +' .ability-left .ability-header').append(AbilityleftheaderTempl.getNEOLeftHeaderTempl(_jsonData, this.store.data.config.serverType));
            $(this.el +' .ability-right .ability-header').append(AbilityrightheaderTempl.getNEORightHeaderTempl(_jsonData, this.store.data.config.serverType));
        }

        $(this.el +' .ability-left .ability-contents').append(AbilityleftcontentsTempl.getLeftContentsTempl(_jsonData, this.store.data.config.serverType));
        $(this.el +' .ability-right .ability-contents').append(AbilityrightcontentsTempl.getRightContentsTempl(_jsonData, this.store.data.config.serverType));

        this.addEvents();
    }

    addEvents(){
        $(document).on('click', '.character-info .ability-left .ability-layer-link', function(e) {
            $(".character-info .ability-left .ability-header-layer").addClass('is-show');
            $('.character-dimmed-layer').addClass('is-dimmed');
            return false;
        });
        $(document).on('click','.character-info .ability-right .ability-layer-link',function(e) {
            $(".character-info .ability-right .ability-header-layer").addClass('is-show');
            $('.character-dimmed-layer').addClass('is-dimmed');
            return false;
        });
        $(document).on('click', '.btn-close-layer', function(e) {
            $(".character-info .ability-header-layer").removeClass('is-show');
            $('.character-dimmed-layer').removeClass('is-dimmed');
            return false;
        });
    }
}

export default AbilityInfo;